// extracted by mini-css-extract-plugin
module.exports = {"newline":"CancellationPolicySection_newline__GRCP7","content":"CancellationPolicySection_content__YqbX_"};